export const NAVIGATED_FROM_INVITATION_LANDING_KEY = 'navigatedFromInvitationLanding';
